import { render, staticRenderFns } from "./KoioteSnap7Connection.vue?vue&type=template&id=2ddf6d96&lang=es"
import script from "./KoioteSnap7Connection.vue?vue&type=script&lang=js"
export * from "./KoioteSnap7Connection.vue?vue&type=script&lang=js"
import style0 from "./KoioteSnap7Connection.vue?vue&type=style&index=0&id=2ddf6d96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports